export function formatCurrency(str: string | number | null | undefined): string {
    const numStr = str?.toString().replace(/[^0-9.]/g, '');
    let [whole, fraction] = numStr?.split('.') ?? [];
    if (fraction || fraction === '') {
        fraction = fraction.slice(0, 2);
        fraction = fraction === '' ? '' : fraction;
    }
    whole = whole?.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return fraction || fraction === '' ? `${whole}.${fraction}` : whole;
}

export function parseCurrency(currencyStr: string): string {
    const numStr = currencyStr?.replace(/,/g, '') || '';
    const [whole, fraction] = numStr.includes('.') ? numStr.split('.') : [numStr, ''];
    return numStr.includes('.') && fraction === ''
        ? whole.concat('.')
        : !numStr.includes('.')
          ? whole
          : whole.concat('.', fraction);
}

export function formatPercentage(str: number | string | null | undefined): string {
    const numStr = str?.toString().replace(/[^0-9.]/g, '');
    let [whole, fraction] = numStr?.split('.') ?? [];
    if (fraction || fraction === '') {
        fraction = fraction.slice(0, 2);
        fraction = fraction === '' ? '' : fraction;
    }
    whole = whole.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return fraction || fraction === '' ? `${whole}.${fraction}` : whole;
}

export function parsePercentage(percentageStr: string): string {
    const numStr = percentageStr?.replace(/,/g, '') || '';
    const [whole, fraction] = numStr.includes('.') ? numStr.split('.') : [numStr, ''];
    return numStr.includes('.') && fraction === ''
        ? whole.concat('.')
        : !numStr.includes('.')
          ? whole
          : whole.concat('.', fraction);
}

export function roundToTwo(num: number) {
    return Math.round(num * 100) / 100;
}

export function generateEightDigitsNumber(): number {
    const randomNumber = Math.floor(10000000 + Math.random() * 90000000);
    return randomNumber;
}
